module.exports = __webpack_public_path__ + "img/elite-map-maker.8670c14c.svg";